// Hook: DELETE /company/locations/{id}

import { axios } from 'api';
import { useMutation, UseMutationOptions } from 'react-query';
import { ICommandResponseError as IError, ICommandResponseSuccess } from 'api/types';

type IResponse = ICommandResponseSuccess;

const deleteCompanyLocation = (id: number): Promise<IResponse> =>
  axios.delete(`/company/locations/${id}`);

export const useDeleteCompanyLocation = (
  options?: UseMutationOptions<IResponse, IError, number>
) => useMutation((id: number) => deleteCompanyLocation(id), options);
